import React from 'react';
import { Tooltip } from 'primereact/tooltip';

/**
 * Creates a truncated text component with tooltip
 * @param {string} text - The text to truncate
 * @param {number} maxLength - Maximum length before truncation (default: 20)
 * @param {string} tooltipId - Unique ID for the tooltip (required)
 * @returns {JSX.Element} - React component with truncated text and tooltip
 */
export const createTruncatedText = (text, maxLength = 20, tooltipId) => {
    if (!text || text.length <= maxLength) {
        return <span>{text}</span>;
    }

    const truncatedText = text.substring(0, maxLength) + '...';
    const uniqueId = tooltipId || `tooltip-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <>
            <span data-pr-tooltip={text} data-pr-position="top" data-pr-showdelay="500" data-pr-hidedelay="100" style={{ cursor: 'help' }}>
                {truncatedText}
            </span>
            <Tooltip target={`.${uniqueId}`} />
        </>
    );
};

/**
 * Creates a truncated text component with tooltip for table cells
 * @param {string} text - The text to truncate
 * @param {number} maxLength - Maximum length before truncation (default: 20)
 * @returns {JSX.Element} - React component with truncated text and tooltip
 */
export const createTruncatedTextForTable = (text, maxLength = 40) => {
    if (!text || text.length <= maxLength) {
        return <span>{text}</span>;
    }

    const truncatedText = text.substring(0, maxLength) + '...';
    const uniqueId = `tooltip-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <>
            <span id={uniqueId} style={{ cursor: 'help' }}>
                {truncatedText}
            </span>
            <Tooltip target={`#${uniqueId}`}>{text}</Tooltip>
        </>
    );
};
